/** The org that publishes Roboto's own Action Hub actions. */
const ROBOTO_PUBLIC_ORG_ID = "roboto-public";

/** Who published a hub action, as the Publisher column names it. */
export function publisherName(orgId: string): string {
  return orgId === ROBOTO_PUBLIC_ORG_ID ? "Roboto" : orgId;
}
